module.exports = __webpack_public_path__ + "img/editalEletronico4.a875d033.jpg";